<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Tabs & accordions component
 */
export default {
  page: {
    title: "User Permissions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "User Permissions",
      items: [
        {
          text: "Adcvanced Settings",
        },
        {
          text: "User permissions ",
          active: true,
        },
      ],
      //VARIABLES
      role_id: atob(this.$route.params.permit_id),
    };
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("users", ["ROLES", "USER_SAVING", "RolePermissions"]),
  },
  methods: {
    ...mapActions({
      FetchUserRoles: "users/fetchUserRoles",
      Fetchrolepermissions: "users/fetchrolepermissions",
      AddUserRole: "users/addUserRole",
      EditUserRole: "users/editUserRole",
      DeleteUserRole: "users/deleteUserRole",
      UpdateRolePermission: "users/updateRolePermission",
    }),

    changePermistion(col, status) {
      let payload = {
        colomn: col,
        status: status,
        role_id: this.RolePermissions.id,
      };
      if (this.RolePermissions.id) {
        this.UpdateRolePermission(payload);
      }
    },
  },
  created() {
    this.Fetchrolepermissions(this.role_id);
    this.FetchUserRoles();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="form-group">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title text-danger">
              Manage User Permissions For
              <b>{{ RolePermissions ? RolePermissions.role_name : "---" }}</b>
              <b-spinner
                v-if="!RolePermissions.role_name"
                class="m-0"
                small
                variant="danger"
                role="status"
              ></b-spinner>
            </h4>
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <!-- DASHBOARD TAB -->
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bx-home-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">DashBoard</span>
                </template>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        <th>ON/OFF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">View Dashboard</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_dashboard == 1"
                              @change="changePermistion('view_dashboard', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_dashboard', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Dashboard Summary</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.dashboard_summary == 1"
                              @change="
                                changePermistion('dashboard_summary', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('dashboard_summary', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Sales Graph</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.sales_graph == 1"
                              @change="changePermistion('sales_graph', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('sales_graph', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Expense Graph</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.expense_graph == 1"
                              @change="changePermistion('expense_graph', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('expense_graph', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Dashboard Filters</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.dashboard_filters == 1"
                              @change="
                                changePermistion('dashboard_filters', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('dashboard_filters', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- CLIENTS MODULE TAB -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bx-hotel"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Patient Module</span>
                </template>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        ON/OFF
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Manage Patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.manage_patients == 1"
                              @change="changePermistion('manage_patients', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('manage_patients', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_patient == 1"
                              @change="changePermistion('add_patient', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_patient', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                       <tr>
                        <th scope="row">View Triage</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_triage == 1"
                              @change="
                                changePermistion('view_triage', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_triage', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Active Patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_active_patient == 1"
                              @change="
                                changePermistion('view_active_patient', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_active_patient', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View All Patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_patients == 1"
                              @change="changePermistion('view_patients', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_patients', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Patient</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_patient == 1"
                              @change="changePermistion('edit_patient', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_patient', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Patient</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_patient == 1"
                              @change="changePermistion('delete_patient', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_patient', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Patient</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_patient == 1"
                              @change="changePermistion('delete_patient', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_patient', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Print Patient Report</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.print_patient_report == 1"
                              @change="
                                changePermistion('print_patient_report', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('print_patient_report', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Order Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.order_service == 1"
                              @change="changePermistion('order_service', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('order_service', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Remove Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.remove_ordered_service == 1"
                              @change="
                                changePermistion('remove_ordered_service', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('remove_ordered_service', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Appointments</th>
                        <td>
                          <div class="form-check form-switch form-switch-lg mb-3">
                            <input
                              v-if="RolePermissions.view_appointments == 1"
                              @change="
                                changePermistion('view_appointments', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_appointments', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Set Appoitment</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.setappoitment == 1"
                              @change="changePermistion('setappoitment', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('setappoitment', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Appoitment</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.editappoitment == 1"
                              @change="changePermistion('editappoitment', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('editappoitment', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Close Appoitment</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.closeappoitment == 1"
                              @change="changePermistion('closeappoitment', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('closeappoitment', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View discharged patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_discharged_patients == 1
                              "
                              @change="
                                changePermistion(
                                  'view_discharged_patients',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'view_discharged_patients',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View refered patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_refered_patients == 1"
                              @change="
                                changePermistion('view_refered_patients', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_refered_patients', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Visit Profile</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.visit_profile == 1"
                              @change="changePermistion('visit_profile', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('visit_profile', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Visit</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_visit == 1"
                              @change="changePermistion('edit_visit', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_visit', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Visit</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_visit == 1"
                              @change="changePermistion('delete_visit', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_visit', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Client Profile</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.client_profile == 1"
                              @change="changePermistion('client_profile', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('client_profile', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- DOCTORS MODULE TAB -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fa fa-medkit"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Doctor Module</span>
                </template>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        <th>ON/OFF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">View Doctor Section</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.is_doctor == 1"
                              @change="changePermistion('is_doctor', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('is_doctor', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add clinical Notes</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_clinical_notes == 1"
                              @change="
                                changePermistion('add_clinical_notes', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_clinical_notes', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- ACCOUNTS MODULE TAB -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bx-money"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Accounts Module</span>
                </template>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        <th>ON/OFF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">View Accounts</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_accounts == 1"
                              @change="changePermistion('view_accounts', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_accounts', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Payments</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_payments == 1"
                              @change="changePermistion('view_payments', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_payments', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Clear Payments</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.clear_payments == 1"
                              @change="changePermistion('clear_payments', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('clear_payments', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Reprint Payments Reciept</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.reprint_payment_receipt == 1
                              "
                              @change="
                                changePermistion('reprint_payment_receipt', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('reprint_payment_receipt', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_services == 1"
                              @change="changePermistion('view_services', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_services', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Close visit</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_close_visit == 1"
                              @change="
                                changePermistion('view_close_visit', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_close_visit', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Clear Debt</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.clear_debt == 1"
                              @change="changePermistion('clear_debt', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('clear_debt', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Discount</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_discount == 1"
                              @change="changePermistion('add_discount', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_discount', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Manage Drugs</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.manage_grugs == 1"
                              @change="changePermistion('manage_grugs', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('manage_grugs', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Print Invoice</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.print_invoice == 1"
                              @change="changePermistion('print_invoice', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('print_invoice', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Generate Invoice</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.generate_invoice == 1"
                              @change="
                                changePermistion('generate_invoice', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('generate_invoice', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Invoice</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_invoice == 1"
                              @change="changePermistion('view_invoice', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_invoice', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Clear Debt</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.clear_debt == 1"
                              @change="changePermistion('clear_debt', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('clear_debt', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">View Debtors</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_debtors == 1"
                              @change="changePermistion('view_debtors', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_debtors', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Account Balance</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_account_balance == 1"
                              @change="
                                changePermistion('view_account_balance', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_account_balance', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Cashflow</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_cashflow == 1"
                              @change="changePermistion('view_cashflow', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_cashflow', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Expense Categories</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_expense_categories == 1
                              "
                              @change="
                                changePermistion('view_expense_categories', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_expense_categories', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                       <tr>
                        <th scope="row">View Expense Items</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_expense_items == 1
                              "
                              @change="
                                changePermistion('view_expense_items', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_expense_items', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Record Expense</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.record_expense == 1"
                              @change="changePermistion('record_expense', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('record_expense', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Reprint Sales Receipt</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.reprint_sale_receipt == 1"
                              @change="
                                changePermistion('reprint_sale_receipt', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('reprint_sale_receipt', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Add Payment Mode</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_payment_mode == 1"
                              @change="
                                changePermistion('add_payment_mode', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_payment_mode', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Payment Mode</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_payment_mode == 1"
                              @change="
                                changePermistion('edit_payment_mode', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_payment_mode', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Payment Mode</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_payment_mode == 1"
                              @change="
                                changePermistion('delete_payment_mode', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_payment_mode', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">View Insurance Patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_insurance_patient_services ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'view_insurance_patient_services',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'view_insurance_patient_services',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Close View Insurance Patients</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.close_insurance_patient_visits ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'close_insurance_patient_visits',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'close_insurance_patient_visits',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Reprint Insurance Payment</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.reprint_insurance_payment == 1
                              "
                              @change="
                                changePermistion(
                                  'reprint_insurance_payment',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'reprint_insurance_payment',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Expense</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_expenses == 1"
                              @change="changePermistion('view_expenses', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_expenses', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Expense</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_expense == 1"
                              @change="changePermistion('edit_expense', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_expense', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Expense</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_expense == 1"
                              @change="changePermistion('delete_expense', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_expense', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Clear Expense Balance</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.clear_expense_balance == 1"
                              @change="
                                changePermistion('clear_expense_balance', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('clear_expense_balance', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- LABORATORY MODULE TAB -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fa fa-flask"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Laboratory Module</span
                  >
                </template>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        <th>ON/OFF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Lab Management</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.lab_management == 1"
                              @change="changePermistion('lab_management', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('lab_management', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Pending Tests</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_pending_tests == 1"
                              @change="
                                changePermistion('view_pending_tests', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_pending_tests', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Tests Reports</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_test_report == 1"
                              @change="
                                changePermistion('view_test_report', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_test_report', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Pick Sample</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.pick_sample == 1"
                              @change="changePermistion('pick_sample', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('pick_sample', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Review Results</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.review_results == 1"
                              @change="changePermistion('review_results', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('review_results', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Print Results</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.print_result == 1"
                              @change="changePermistion('print_result', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('print_result', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Organism</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_organism == 1"
                              @change="changePermistion('add_organism', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_organism', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Organism</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_organism == 1"
                              @change="changePermistion('edit_organism', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_organism', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Organism</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_organism == 1"
                              @change="changePermistion('delete_organism', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_organism', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Antibiotics</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_antibiotics == 1"
                              @change="
                                changePermistion('view_antibiotics', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_antibiotics', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Antibiotic</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_antibiotic == 1"
                              @change="changePermistion('add_antibiotic', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_antibiotic', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Antibiotic</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_antibiotic == 1"
                              @change="changePermistion('edit_antibiotic', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_antibiotic', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Antibiotic</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_antibiotic == 1"
                              @change="
                                changePermistion('delete_antibiotic', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_antibiotic', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Sample</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_sample == 1"
                              @change="changePermistion('add_sample', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_sample', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Sample</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_sample == 1"
                              @change="changePermistion('edit_sample', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_sample', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Sample</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_sample == 1"
                              @change="changePermistion('delete_sample', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_sample', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add lab service sample</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_labservice_sample == 1"
                              @change="
                                changePermistion('add_labservice_sample', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_labservice_sample', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Lab Inventory</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_invetory == 1"
                              @change="changePermistion('view_invetory', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_invetory', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Inventory Stocking</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.invetory_stocking == 1"
                              @change="
                                changePermistion('invetory_stocking', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('invetory_stocking', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Inventory Items</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.invetory_items == 1"
                              @change="changePermistion('invetory_items', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('invetory_items', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Inventory Disbursed</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.disbursed_stock == 1"
                              @change="changePermistion('disbursed_stock', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('disbursed_stock', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Inventory Make Requisition</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.make_requisition == 1"
                              @change="
                                changePermistion('make_requisition', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('make_requisition', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View requisitions</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_requisitions == 1"
                              @change="
                                changePermistion('view_requisitions', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_requisitions', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- PHARMACY MODULE TAB -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fa fa-capsules"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Pharmacy Module</span>
                </template>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        <th>ON/OFF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Manage Pharmacy</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.manage_pharmacy == 1"
                              @change="changePermistion('manage_pharmacy', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('manage_pharmacy', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Dispense</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_dispense == 1"
                              @change="changePermistion('view_dispense', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_dispense', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Stock</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_stock == 1"
                              @change="changePermistion('add_stock', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_stock', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Stock</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_stock == 1"
                              @change="changePermistion('view_stock', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_stock', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Make Sale</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.make_sale == 1"
                              @change="changePermistion('make_sale', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('make_sale', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Product Sales</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_product_sales == 1"
                              @change="
                                changePermistion('view_product_sales', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_product_sales', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Purchases</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_purchases == 1"
                              @change="changePermistion('view_purchases', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_purchases', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Product Purchase</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_product_purchase == 1"
                              @change="
                                changePermistion('view_product_purchase', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_product_purchase', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Product Expiry</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_product_expiry == 1"
                              @change="
                                changePermistion('view_product_expiry', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_product_expiry', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Prescription</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_prescription == 1"
                              @change="
                                changePermistion('add_prescription', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_prescription', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Dispense Detatils</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_dispense_detatils == 1"
                              @change="
                                changePermistion('view_dispense_detatils', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_dispense_detatils', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Priscription</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_priscription == 1"
                              @change="
                                changePermistion('edit_priscription', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_priscription', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Priscription</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_prescription == 1"
                              @change="
                                changePermistion('delete_prescription', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_prescription', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Dispense Priscription</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.dispense_priscription == 1"
                              @change="
                                changePermistion('dispense_priscription', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('dispense_priscription', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Reconsile Stock</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.reconsile_stock == 1"
                              @change="changePermistion('reconsile_stock', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('reconsile_stock', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Paharmacy Debtors</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_paharmacy_debtors == 1"
                              @change="
                                changePermistion('view_paharmacy_debtors', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_paharmacy_debtors', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Purchase Filters</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_purchase_filters == 1"
                              @change="
                                changePermistion('view_purchase_filters', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_purchase_filters', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Creditors</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_creditors == 1"
                              @change="changePermistion('view_creditors', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_creditors', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Return Purchase</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.return_purchase == 1"
                              @change="changePermistion('return_purchase', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('return_purchase', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Remove Expired Stock</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.remove_expired_staock == 1"
                              @change="
                                changePermistion('remove_expired_staock', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('remove_expired_staock', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Reprint sale receipt</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.reprint_sale_receipt == 1"
                              @change="
                                changePermistion('reprint_sale_receipt', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('reprint_sale_receipt', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">View incomplete dosage</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.View_incomplete_dosage == 1"
                              @change="
                                changePermistion('View_incomplete_dosage', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('View_incomplete_dosage', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Sales Report</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.sales_report == 1"
                              @change="changePermistion('sales_report', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('sales_report', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- ADVANCED SETTINGS TAB -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-cog"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >Advanced Sections</span
                  >
                </template>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        <th>ON/OFF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">View Advanced Settings</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_advanced_settings == 1"
                              @change="
                                changePermistion('view_advanced_settings', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_advanced_settings', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View In Patient</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.in_patient == 1"
                              @change="changePermistion('in_patient', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('in_patient', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr v-if="RolePermissions.manage_branches == 1">
                        <th scope="row">Manage Branches</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.manage_branches == 1"
                              @change="changePermistion('manage_branches', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('manage_branches', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Consultation Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_consultations == 1"
                              @change="
                                changePermistion('view_consultations', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_consultations', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Consultation</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_consultaion == 1"
                              @change="changePermistion('add_consultaion', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_consultaion', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Consultation</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_consultaion == 1"
                              @change="
                                changePermistion('edit_consultaion', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_consultaion', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Consultation</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_consultaion == 1"
                              @change="
                                changePermistion('delete_consultaion', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_consultaion', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Dental Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_dental == 1"
                              @change="changePermistion('view_dental', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_dental', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Dental Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_dental == 1"
                              @change="changePermistion('add_dental', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_dental', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Dental Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_dental == 1"
                              @change="changePermistion('edit_dental', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_dental', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Dental Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_dental == 1"
                              @change="changePermistion('delete_dental', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_dental', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Antenatal Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.antenatal_services == 1"
                              @change="
                                changePermistion('antenatal_services', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('antenatal_services', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Antenatal Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_antenental == 1"
                              @change="changePermistion('add_antenental', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_antenental', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Antenatal Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_antelogy == 1"
                              @change="changePermistion('edit_antelogy', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_antelogy', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Antenatal Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_antenental == 1"
                              @change="
                                changePermistion('delete_antenental', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_antenental', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Radiology Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_radiology == 1"
                              @change="changePermistion('view_radiology', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_radiology', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Radiology</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_radiology == 1"
                              @change="changePermistion('add_radiology', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_radiology', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Radiology Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_radiology == 1"
                              @change="changePermistion('edit_radiology', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_radiology', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Radiology Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_radiology == 1"
                              @change="
                                changePermistion('delete_radiology', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_radiology', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Procedure Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_procedures == 1"
                              @change="changePermistion('view_procedures', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_procedures', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Procedure Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_procedure == 1"
                              @change="changePermistion('add_procedure', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_procedure', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Procedure Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_procedure == 1"
                              @change="changePermistion('edit_procedure', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_procedure', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Procedure Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_procedure == 1"
                              @change="
                                changePermistion('delete_procedure', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_procedure', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Lab-categories</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_labservice_categories == 1
                              "
                              @change="
                                changePermistion(
                                  'view_labservice_categories',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'view_labservice_categories',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Lab-category</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_labcategory == 1"
                              @change="changePermistion('add_labcategory', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_labcategory', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Lab-category</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_labcategory == 1"
                              @change="
                                changePermistion('edit_labcategory', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_labcategory', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Lab-category</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_labcategory == 1"
                              @change="
                                changePermistion('delete_labcategory', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_labcategory', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Lab Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_labservices == 1"
                              @change="
                                changePermistion('view_labservices', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_labservices', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Lab Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_labservice == 1"
                              @change="changePermistion('add_labservice', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_labservice', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Lab Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_labservice == 1"
                              @change="changePermistion('edit_labservice', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_labservice', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Lab Service</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_labservice == 1"
                              @change="
                                changePermistion('delete_labservice', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_labservice', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Test Option</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_result_options == 1"
                              @change="
                                changePermistion('view_result_options', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_result_options', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Test Option</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_test_option == 1"
                              @change="changePermistion('add_test_option', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_test_option', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Test Option</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_test_option == 1"
                              @change="
                                changePermistion('edit_test_option', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_test_option', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Test Option</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_test_option == 1"
                              @change="
                                changePermistion('delete_test_option', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_test_option', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Test Option</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_test_option == 1"
                              @change="
                                changePermistion('delete_test_option', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_test_option', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Suppliers</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_suppliers == 1"
                              @change="changePermistion('view_suppliers', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_suppliers', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Units</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_units == 1"
                              @change="changePermistion('view_units', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_units', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View item categories</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_item_categores == 1"
                              @change="
                                changePermistion('view_item_categores', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_item_categores', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View pharmacy items</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_pharmacy_items == 1"
                              @change="
                                changePermistion('view_pharmacy_items', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_pharmacy_items', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Permissions</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_permissions == 1"
                              @change="
                                changePermistion('view_permissions', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_permissions', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Positions</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_positions == 1"
                              @change="changePermistion('view_positions', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_positions', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View user roles</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_user_roles == 1"
                              @change="changePermistion('view_user_roles', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_user_roles', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Payment Modes</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_payment_modes == 1"
                              @change="
                                changePermistion('view_payment_modes', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_payment_modes', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Payments</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_payments == 1"
                              @change="changePermistion('view_payments', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_payments', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Audits</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_audits == 1"
                              @change="changePermistion('view_audits', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_audits', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View user logs</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_user_logs == 1"
                              @change="changePermistion('view_user_logs', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_user_logs', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Suppliers</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_suppliers == 1"
                              @change="changePermistion('add_suppliers', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_suppliers', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Suppliers</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_suppliers == 1"
                              @change="changePermistion('edit_suppliers', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_suppliers', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Suppliers</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_suppliers == 1"
                              @change="
                                changePermistion('delete_suppliers', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_suppliers', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Units</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_units == 1"
                              @change="changePermistion('add_units', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_units', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Units</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_units == 1"
                              @change="changePermistion('edit_units', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_units', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Units</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_units == 1"
                              @change="changePermistion('delete_units', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_units', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View LPOs</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_lpos == 1"
                              @change="changePermistion('view_lpos', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_lpos', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Generate LPO</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.generate_lpo == 1"
                              @change="changePermistion('generate_lpo', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('generate_lpo', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Approve LPO</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.approve_lpo == 1"
                              @change="changePermistion('approve_lpo', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('approve_lpo', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Change LPO Supplier</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.change_lpo_supplier == 1"
                              @change="
                                changePermistion('change_lpo_supplier', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('change_lpo_supplier', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Items on LPO</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_lpo_item == 1"
                              @change="changePermistion('add_lpo_item', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_lpo_item', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View LPO Details</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_lpo_details == 1"
                              @change="
                                changePermistion('view_lpo_details', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_lpo_details', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete LPO</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_lpo == 1"
                              @change="changePermistion('delete_lpo', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_lpo', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Pharmacy Categories</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.add_pharmacy_categories == 1
                              "
                              @change="
                                changePermistion('add_pharmacy_categories', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_pharmacy_categories', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Pharmacy Categories</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.edit_pharmacy_categories == 1
                              "
                              @change="
                                changePermistion(
                                  'edit_pharmacy_categories',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'edit_pharmacy_categories',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Pharmacy Categories</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.delete_pharmacy_categories == 1
                              "
                              @change="
                                changePermistion(
                                  'delete_pharmacy_categories',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'delete_pharmacy_categories',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Pharmacy Item</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_pharmacy_item == 1"
                              @change="
                                changePermistion('add_pharmacy_item', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_pharmacy_item', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Out of Stock report</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_stock_out == 1"
                              @change="changePermistion('view_stock_out', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_stock_out', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Pharmacy Item</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_pharmacy_item == 1"
                              @change="
                                changePermistion('edit_pharmacy_item', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_pharmacy_item', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Pharmacy Item</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_pharmacy_item == 1"
                              @change="
                                changePermistion('delete_pharmacy_item', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_pharmacy_item', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Position</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_position == 1"
                              @change="changePermistion('add_position', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_position', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">Edit Position</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_position == 1"
                              @change="changePermistion('edit_position', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_position', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Position</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_position == 1"
                              @change="changePermistion('delete_position', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_position', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add User Role</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_user_role == 1"
                              @change="changePermistion('add_user_role', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_user_role', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit User Role</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_user_role == 1"
                              @change="changePermistion('edit_user_role', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_user_role', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete User Role</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_user_role == 1"
                              @change="
                                changePermistion('delete_user_role', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_user_role', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">manage Users</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_users == 1"
                              @change="changePermistion('view_users', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_users', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">manage staff</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.manage_staff == 1"
                              @change="changePermistion('manage_staff', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('manage_staff', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Staff</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_staff == 1"
                              @change="changePermistion('add_staff', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('add_staff', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Staff</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_staff == 1"
                              @change="changePermistion('edit_staff', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('edit_staff', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Staff</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_staff == 1"
                              @change="changePermistion('delete_staff', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_staff', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Staff Profile</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.staff_profile == 1"
                              @change="changePermistion('staff_profile', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('staff_profile', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Enroll Staff</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.enroll_staff == 1"
                              @change="changePermistion('enroll_staff', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('enroll_staff', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Expense Category</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_expense_category == 1"
                              @change="
                                changePermistion('add_expense_category', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_expense_category', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Expense Category</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_expense_category == 1"
                              @change="
                                changePermistion('edit_expense_category', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_expense_category', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Expense Category</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.delete_expense_category == 1
                              "
                              @change="
                                changePermistion('delete_expense_category', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('delete_expense_category', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Notifiction</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_notifiction == 1"
                              @change="
                                changePermistion('view_notifiction', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_notifiction', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Massages</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_massages == 1"
                              @change="changePermistion('view_massages', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('view_massages', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">General Settings</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.general_settings == 1"
                              @change="
                                changePermistion('general_settings', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('general_settings', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Send Messages</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.send_messages == 1"
                              @change="changePermistion('send_messages', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('send_messages', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Messages Center</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.sms_center == 1"
                              @change="changePermistion('sms_center', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('sms_center', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Insurance Company Statement</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_insurance_company_statement ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'view_insurance_company_statement',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'view_insurance_company_statement',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Insurance Package Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_insurance_company_package_services ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'view_insurance_company_package_services',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'view_insurance_company_package_services',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Package Services</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.edit_insurance_company_package_services ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'edit_insurance_company_package_services',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'edit_insurance_company_package_services',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Insurance Packages</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.view_insurance_company_packages ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'view_insurance_company_packages',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'view_insurance_company_packages',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Insurance Packages</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.add_insurance_company_packages ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'add_insurance_company_packages',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'add_insurance_company_packages',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Insurance Packages</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.edit_insurance_company_packages ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'edit_insurance_company_packages',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'edit_insurance_company_packages',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Insurance Packages</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.delete_insurance_company_packages ==
                                1
                              "
                              @change="
                                changePermistion(
                                  'delete_insurance_company_packages',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'delete_insurance_company_packages',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Insurance Companies</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_insurance_company == 1"
                              @change="
                                changePermistion('view_insurance_company', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_insurance_company', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete Insurance Comapany</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="
                                RolePermissions.delete_insurance_company == 1
                              "
                              @change="
                                changePermistion(
                                  'delete_insurance_company',
                                  '0'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion(
                                  'delete_insurance_company',
                                  '1'
                                )
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit Insurance Comapany</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.edit_insurance_company == 1"
                              @change="
                                changePermistion('edit_insurance_company', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('edit_insurance_company', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Add Insurance Comapany</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.add_insurance_company == 1"
                              @change="
                                changePermistion('add_insurance_company', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('add_insurance_company', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Suspend user</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.suspend_user == 1"
                              @change="changePermistion('suspend_user', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('suspend_user', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Delete User</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.delete_user == 1"
                              @change="changePermistion('delete_user', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('delete_user', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Change User Role</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.change_user_role == 1"
                              @change="
                                changePermistion('change_user_role', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('change_user_role', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- TOP REPORTS TAB -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-file"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Facility Reports</span>
                </template>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Permission</th>
                        <th>ON/OFF</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">View Facility Reports</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.facility_reports == 1"
                              @change="
                                changePermistion('facility_reports', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('facility_reports', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Shift Report</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.view_shift_reports == 1"
                              @change="
                                changePermistion('view_shift_reports', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('view_shift_reports', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Print Shift Report</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.print_shift_report == 1"
                              @change="
                                changePermistion('print_shift_report', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('print_shift_report', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Shift Reports comments</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.shift_report_comments == 1"
                              @change="
                                changePermistion('shift_report_comments', '0')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="
                                changePermistion('shift_report_comments', '1')
                              "
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">View Turn Around Time Report</th>
                        <td>
                          <div
                            class="form-check form-switch form-switch-lg mb-3"
                          >
                            <input
                              v-if="RolePermissions.tat_report == 1"
                              @change="changePermistion('tat_report', '0')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                              checked
                            />
                            <input
                              v-else
                              @change="changePermistion('tat_report', '1')"
                              class="form-check-input"
                              type="checkbox"
                              id="SwitchCheckSizelg"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
